export const FEE_RECURRENCES = {
  ONE_TIME: 'one-time',
  DAILY: 'daily',
  FORTNIGHTLY: 'fortnightly',
  MONTHLY: 'monthly',
  YEARLY: 'yearly',
  OPTIONAL: 'optional'
};
